import isPlainObject from "lodash.isplainobject";
import mapValues from "lodash.mapvalues";
export function isStateTransition(a) {
    return a && a.isStateTransition;
}
function cloneDeep(value) {
    if (Array.isArray(value)) {
        return value.map(cloneDeep);
    }
    if (isPlainObject(value)) {
        return mapValues(value, cloneDeep);
    }
    if (value instanceof Set) {
        return new Set(cloneDeep(Array.from(value)));
    }
    if (value instanceof Map) {
        return new Map(cloneDeep(Array.from(value)));
    }
    return value;
}
export function state(name, executor, options) {
    const immutable = !options || !options.mutable;
    const fn = (...data) => {
        return {
            name,
            data,
            isStateTransition: true,
            mode: "append",
            reenter: (...reenterArgs) => {
                const bound = fn(...reenterArgs);
                bound.mode = "append";
                return bound;
            },
            executor: (action) => {
                // Clones arguments
                const clonedArgs = immutable ? data.map(cloneDeep) : data;
                // Run state execturoe
                return executor(action, ...clonedArgs);
            },
        };
    };
    Object.defineProperty(fn, "name", { value: name });
    fn.reenter = (...args) => {
        const bound = fn(...args);
        bound.mode = "append";
        return bound;
    };
    fn.update = (...args) => {
        const bound = fn(...args);
        bound.mode = "update";
        return bound;
    };
    return fn;
}
//# sourceMappingURL=state.js.map